module.exports = __webpack_public_path__ + "img/条约查看记录.7b9f971f.svg";